/**
 * Type:
 * 0 = Non Stadion Measured
 * 1 = Non Stadion Non Measured
 * 2 = Non Stadion Mixed Measured
 */

const competitionKind = [
	{
		text: '', key: null, value: 0, type: [0, 1, 2],
	},
	{
		text: '', key: 'text.competitionApprovalArt.streetRun', value: 1, type: [0, 1, 2],
	},
	{
		text: '', key: 'text.competitionApprovalArt.crossCountry', value: 2, type: [1, 2],
	},
	{
		text: '', key: 'text.competitionApprovalArt.mountainRun', value: 3, type: [1, 2],
	},
	{
		text: '', key: 'text.competitionApprovalArt.streetWalk', value: 4, type: [0, 1, 2],
	},
	{
		text: '', key: 'text.competitionApprovalArt.else', value: 5, type: [1, 2],
	},
	{
		text: '', key: 'text.competitionApprovalArt.peoplesRun', value: 6, type: [0, 1, 2],
	},
];

function getCompetitionKind(_this, filter) {
	if (filter == null) return null;
	competitionKind.forEach((x) => {
		if (x.key != null) x.text = _this.$t(x.key);
	});
	return competitionKind.filter(x => x.type.includes(filter));
}

export default getCompetitionKind;
